/**
 * DEV-ONLY test page for previewing the SupervisorOverrideModal UI.
 * Navigate to /dev/supervisor-override to see it.
 * Remove this file before production deployment.
 */
import React, { useState } from 'react';
import { useLanguage } from '../../i18n/LanguageContext';
import { SupervisorOverrideModal } from './modals';
import type { ProductionSession } from '../../services/operatorService';

const mockSession: ProductionSession = {
  session_number: 'SESS-2026-TEST',
  sub_session_number: 'SUB-TEST-001',
  is_sub_session: true,
  product_sku: '46751713652532',
  product_name: 'Pork Gyoza (12pc)',
  product_chinese: '豬肉煎餃 (12入)',
  product_unit_weight: 24,
  box_target_weight: 24,
  packing: 12,
  yield_factor: 0.85,
  station_id: 1,
  station_number: 1,
  station_name: 'Station 1',
  station_type: 'packing',
  raw_material_item_number: 'RM-001',
  raw_material_name: 'Pork Filling Blend',
  raw_material_chinese: '豬肉餡料',
  raw_material_lot: 'LOT-2026-042',
  supervisor_name: 'John Supervisor',
  session_status: 'active',
  status: 'active',
  initial_material_weight: 500,
  target_output_weight: 425,
  actual_output_weight: 312.5,
  waste_weight: 18.2,
  yield_percentage: 82.1,
  expected_yield: 85,
  started_at: '2026-01-27T08:00:00Z',
  completed_at: null,
  notes: null,
};

const SupervisorOverrideTestPage: React.FC = () => {
  const { t } = useLanguage();
  const [isOpen, setIsOpen] = useState(true);
  const [manualWeightActive, setManualWeightActive] = useState(false);

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 p-8">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
          Supervisor Override Modal — Test Page
        </h1>
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          This page renders the SupervisorOverrideModal with mock data for UI preview.
        </p>

        <div className="space-y-3 mb-6">
          <div className="flex items-center gap-3">
            <span className="text-sm text-gray-500 dark:text-gray-400">Manual weight mode:</span>
            <span className={`px-2 py-1 text-xs rounded-full font-medium ${
              manualWeightActive
                ? 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300'
                : 'bg-gray-100 text-gray-500 dark:bg-gray-800 dark:text-gray-400'
            }`}>
              {manualWeightActive ? 'ACTIVE' : 'OFF'}
            </span>
          </div>
        </div>

        <button
          onClick={() => setIsOpen(true)}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
        >
          Open Override Modal
        </button>
      </div>

      <SupervisorOverrideModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        supervisorId="SUP-001"
        supervisorName="Maria Supervisor"
        session={mockSession}
        operatorEmployeeNumber="OP-042"
        operatorName="Carlos Operator"
        onManualWeightToggle={(mode) => setManualWeightActive(mode === 'catch')}
      />
    </div>
  );
};

export default SupervisorOverrideTestPage;
